import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > button {
    background: #4cd964;
    color: #fff;
  }
`;

export const LastTableNumber = styled.div`
  color: #4cd964;
  font-size: 45px;
  background-color: #dfffec;
  width: 86px;
  height: 86px;
  border-radius: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const LastTableTitle = styled.p`
  font-size: 18px;
  color: #8e8e93;
  font-family: 'FontsFreeNetSFProTextLight';
`;
